// data.js
const dataSource = [
  { key: '1', pathology: 'Infarctus du myocarde', region: 'Coeur', date: '18/12/2024', course: 'RAD-123', owner: 'Dr. Raidium' },
  { key: '2', pathology: 'Tumeurs hépatiques', region: 'Foie', date: '18/12/2024', course: 'RAD-234', owner: 'Dr. Raidium' },
  { key: '3', pathology: 'Tumeurs pulmonaires', region: 'Poumon', date: '18/12/2024', course: 'RAD-345', owner: 'Dr. Beaujon' },
  { key: '4', pathology: 'AVC', region: 'Cerveau', date: '20/12/2024', course: 'RAD-456', owner: 'Dr. Dupuis' },
  { key: '5', pathology: 'Kyste rénal', region: 'Rein', date: '22/12/2024', course: 'RAD-567', owner: 'Dr. Martin' },
  { key: '6', pathology: 'Lésion vertébrale', region: 'Colonne', date: '25/12/2024', course: 'RAD-678', owner: 'Dr. Leroy' },
  { key: '7', pathology: 'Tumeur pancréatique', region: 'Pancréas', date: '28/12/2024', course: 'RAD-789', owner: 'Dr. Girard' },
  { key: '8', pathology: 'Abcès hépatique', region: 'Foie', date: '30/12/2024', course: 'RAD-890', owner: 'Dr. Raidium' },
  { key: '9', pathology: 'Fracture osseuse', region: 'Jambe', date: '02/01/2025', course: 'RAD-901', owner: 'Dr. Raidium' },
  { key: '10', pathology: 'Tumeur cérébrale', region: 'Cerveau', date: '05/01/2025', course: 'RAD-012', owner: 'Dr. Dupuis' },
  { key: '11', pathology: 'Valvulopathie', region: 'Coeur', date: '08/01/2025', course: 'RAD-123', owner: 'Dr. Beaujon' },
  { key: '12', pathology: 'Nodule thyroïdien', region: 'Thyroïde', date: '10/01/2025', course: 'RAD-234', owner: 'Dr. Martin' },
  { key: '13', pathology: 'Métastases pulmonaires', region: 'Poumon', date: '15/01/2025', course: 'RAD-345', owner: 'Dr. Leroy' },
  { key: '14', pathology: 'Calculs rénaux', region: 'Rein', date: '18/01/2025', course: 'RAD-456', owner: 'Dr. Girard' },
  { key: '15', pathology: 'Anévrisme aortique abdominal', region: 'Abdomen', date: '20/01/2025', course: 'RAD-567', owner: 'Dr. Raidium' },
  { key: '16', pathology: 'Arthrose du genou', region: 'Genou', date: '22/01/2025', course: 'RAD-678', owner: 'Dr. Leroy' },
  { key: '17', pathology: 'Fracture de la hanche', region: 'Hanche', date: '25/01/2025', course: 'RAD-678', owner: 'Dr. Dupuis' },
  { key: '18', pathology: 'Tendinopathie de l’épaule', region: 'Épaule', date: '28/01/2025', course: 'RAD-678', owner: 'Dr. Leroy' },
  { key: '19', pathology: 'Maladie de Crohn', region: 'Intestin', date: '30/01/2025', course: 'RAD-789', owner: 'Dr. Girard' },
  { key: '20', pathology: 'Cancer du côlon', region: 'Côlon', date: '02/02/2025', course: 'RAD-789', owner: 'Dr. Martin' },
  { key: '21', pathology: 'Pancréatite aiguë', region: 'Pancréas', date: '05/02/2025', course: 'RAD-789', owner: 'Dr. Girard' },
  { key: '22', pathology: 'Asthme sévère', region: 'Poumon', date: '12/03/2025', course: 'RAD-876', owner: 'Dr. Hérent' },
  { key: '23', pathology: 'Bronchiolite', region: 'Poumon', date: '14/03/2025', course: 'RAD-876', owner: 'Dr. Hérent' },
  { key: '24', pathology: 'Reflux gastro-œsophagien', region: 'Œsophage', date: '20/03/2025', course: 'RAD-876', owner: 'Dr. Martin' },
];

const courses = [
  {
    id: 'RAD-123',
    name: 'Imagerie Cardiaque',
    owner: 'Dr. Raidium',
    editors: ['Dr. Beaujon', 'Dr. Martin'],
    description: 'Pathologies cardiaques et imagerie interventionnelle',
    status: 'published',
    createdAt: '2024-09-15',
    updatedAt: '2025-01-08',
  },
  {
    id: 'RAD-234',
    name: 'Hépatologie et Imagerie Digestive',
    owner: 'Dr. Raidium',
    editors: ['Dr. Martin'],
    description: 'Étude des pathologies hépatiques et digestives',
    status: 'published',
    createdAt: '2024-09-20',
    updatedAt: '2025-01-10',
  },
  {
    id: 'RAD-345',
    name: 'Imagerie Thoracique',
    owner: 'Dr. Beaujon',
    editors: ['Dr. Leroy'],
    description: 'Pathologies pulmonaires et thoraciques',
    status: 'published',
    createdAt: '2024-10-05',
    updatedAt: '2025-01-15',
  },
  {
    id: 'RAD-456',
    name: 'Neuroradiologie',
    owner: 'Dr. Dupuis',
    editors: ['Dr. Girard'],
    description: 'Imagerie du système nerveux central',
    status: 'published',
    createdAt: '2024-10-12',
    updatedAt: '2025-01-18',
  },
  {
    id: 'RAD-567',
    name: 'Imagerie Urologique',
    owner: 'Dr. Martin',
    editors: ['Dr. Raidium'],
    description: 'Pathologies du système urinaire',
    status: 'published',
    createdAt: '2024-11-03',
    updatedAt: '2025-01-20',
  },
  {
    id: 'RAD-678',
    name: 'Imagerie Musculo-Squelettique',
    owner: 'Dr. Leroy',
    editors: ['Dr. Dupuis'],
    description: 'Exploration des pathologies osseuses et articulaires',
    status: 'published',
    createdAt: '2024-11-15',
    updatedAt: '2025-01-28',
  },
  {
    id: 'RAD-789',
    name: 'Imagerie Digestive Avancée',
    owner: 'Dr. Girard',
    editors: ['Dr. Martin'],
    description: 'Analyse approfondie des pathologies gastro-intestinales',
    status: 'published',
    createdAt: '2024-12-01',
    updatedAt: '2025-02-05',
  },
  {
    id: 'RAD-876',
    name: 'Imagerie Pédiatrique',
    owner: 'Dr. Hérent',
    editors: ['Dr. Martin'],
    description: 'Pathologies en imagerie pédiatrique',
    status: 'published',
    createdAt: '2025-02-01',
    updatedAt: '2025-03-20',
  },
  {
    id: 'RAD-987',
    name: 'Imagerie Interventionnelle (en préparation)',
    owner: 'Dr. Hérent',
    editors: [],
    description: 'Cours en cours de rédaction — gestes guidés par imagerie',
    status: 'draft',
    createdAt: '2025-04-10',
    updatedAt: '2025-04-10',
  },
];

const getCourseProfessors = (course) =>
  course ? [course.owner, ...(course.editors || [])] : [];

// Permission helpers are id-based (display names can collide). `me` may be the
// user object ({id, full_name}) or, for back-compat, a display-name string.
const isCourseOwner = (course, me) => {
  if (!course || !me) return false;
  if (typeof me === "string") return course.owner === me;
  return course.ownerId != null
    ? course.ownerId === me.id
    : course.owner === me.full_name;
};

const isCourseEditor = (course, me) => {
  if (!course || !me) return false;
  if (typeof me === "string") return (course.editors || []).includes(me);
  return course.editorIds && course.editorIds.length
    ? course.editorIds.includes(me.id)
    : (course.editors || []).includes(me.full_name);
};

const isCourseMember = (course, me) =>
  isCourseOwner(course, me) || isCourseEditor(course, me);

export {
  dataSource,
  courses,
  getCourseProfessors,
  isCourseOwner,
  isCourseEditor,
  isCourseMember,
};
